// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 19 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.83073 18.3307V9.16406M1.66406 10.8307V16.6641C1.66406 17.5845 2.41025 18.3307 3.33073 18.3307H14.5193C15.7532 18.3307 16.8026 17.4305 16.9902 16.2109L17.8876 10.3775C18.1206 8.86314 16.9489 7.4974 15.4167 7.4974H12.4974C12.0372 7.4974 11.6641 7.1243 11.6641 6.66406V3.71893C11.6641 2.58406 10.7441 1.66406 9.6092 1.66406C9.33851 1.66406 9.09321 1.82348 8.98328 2.07083L6.05068 8.66918C5.91693 8.97012 5.61849 9.16406 5.28917 9.16406H3.33073C2.41025 9.16406 1.66406 9.91025 1.66406 10.8307Z"
    />
  </svg>
);
const IconThumbUp = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconThumbUp;
